import { Dispatch, SetStateAction, useState } from 'react';
import { QueryKey, UseQueryResult, useQuery } from 'react-query';
import moment from 'moment';

import { GetEligibleEmployees } from '@pimm/services/lib/sms-workforce/services';
import { GetEligibleEmployeesQueryParams } from '@pimm/services/lib/sms-workforce';

export type GetEligibleEmployeesParams = Omit<GetEligibleEmployeesQueryParams, 'dateTime'> & {
  dateTime?: Date;
};

export const useGetEligibleEmployees = (props?: {
  queryKey?: string;
  query?: GetEligibleEmployeesParams;
}): [UseQueryResult<Awaited<ReturnType<typeof GetEligibleEmployees>>>, Dispatch<SetStateAction<GetEligibleEmployeesParams>>] => {
  const [query, setQuery] = useState<GetEligibleEmployeesParams>({ ...props?.query });

  const schedules = useQuery({
    cacheTime: 0,
    enabled: !!query?.siteId && !!query?.dateTime,
    queryKey: [props?.queryKey ?? 'GetEligibleEmployees', query] as [QueryKey, GetEligibleEmployeesParams],
    queryFn: ({ queryKey: [key, params] }) => {
      return GetEligibleEmployees({
        siteId: params.siteId,
        dateTime: moment(params.dateTime).format().slice(0, 19),
        positionId: params.positionId,
      });
    },
  });

  return [schedules, setQuery];
};
